import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { RestaurantLogo } from '@/components/brand/restaurant-logo';
import { ArrowRight } from 'lucide-react';
import { useAuth } from '@/hooks/use-auth';
import { buttonClasses } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function SiteHeader() {
  const { user, logout } = useAuth();
  // Soft shadow once the page is scrolled.
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const navCls = ({ isActive }: { isActive: boolean }) =>
    cn(
      'rounded-full px-3 py-2 text-sm font-medium hover:bg-ink-100',
      isActive ? 'text-ink-900' : 'text-ink-600',
    );

  return (
    <header
      className={cn(
        'animate-slide-down sticky top-0 z-30 border-b bg-cream/90 backdrop-blur transition-shadow duration-300',
        scrolled ? 'border-ink-200 shadow-md shadow-ink-900/5' : 'border-ink-200/70',
      )}
    >
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between gap-4 px-4 sm:px-6">
        <Link
          to="/"
          className="group flex shrink-0 items-center gap-2 whitespace-nowrap font-display text-lg font-bold text-ink-900 sm:text-xl"
        >
          <RestaurantLogo size={36} />
          Grow My Restaurant
        </Link>
        <nav aria-label="Main" className="flex items-center gap-1">
          {user ? (
            <>
              <NavLink to="/dashboard" className={navCls}>
                My reports
              </NavLink>
              <button
                type="button"
                onClick={() => void logout()}
                className="rounded-full px-3 py-2 text-sm font-medium text-ink-600 hover:bg-ink-100"
              >
                Sign out
              </button>
            </>
          ) : (
            <NavLink to="/login" className={navCls}>
              Sign in
            </NavLink>
          )}
          <Link
            to="/grade"
            className={buttonClasses('primary', 'sm', 'cta-attention ml-1 hidden sm:inline-flex')}
          >
            Grade My Restaurant
            <ArrowRight className="cta-arrow size-3.5" aria-hidden />
          </Link>
        </nav>
      </div>
    </header>
  );
}
